'use client';

import type { Message } from '@repo/api';
import { StarRating } from '@/components/ui/StarRating';
import { useAnalytics } from '@/hooks/useAnalytics';

interface StarRatingCardProps {
  message: Message;
  onSlotSelect: (value: string, message: Message) => void;
}

export function StarRatingCard({ message, onSlotSelect }: StarRatingCardProps) {
  const data = (message.contentData as any[]) ?? [];
  const analytics = useAnalytics();

  const isSubmitted = data.some((e: any) => e?.isSelect === true);
  const selectedItem = data.find((e: any) => e?.isSelect === true);
  const value = isSubmitted && selectedItem ? Number(selectedItem.value) || 0 : 0;

  return (
    <div className="w-full flex items-center py-2 ml-12">
      <div className="inline-flex bg-secondary p-3 rounded-full">
        <StarRating
          rating={value ?? 0}
          starSize={24}
          starSpace={12}
          fillClassName="icon-rating"
          emptyClassName={isSubmitted ? 'icon-tertiary opacity-50' : 'icon-tertiary'}
          outlineEmpty
          isStatic={isSubmitted}
          onRatingChange={rating => {
            if (!isSubmitted) {
              void analytics.track('chat_rating', { rating: rating as 1 | 2 | 3 | 4 | 5 });
              onSlotSelect(String(rating), message);
            }
          }}
        />
      </div>
    </div>
  );
}
